import axios from 'axios'

const baseURL = window.location.origin + window.location.pathname.replace(/\/$/, "");

export default () => {
  return axios.create({

    baseURL: baseURL,

    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}